import React, { useEffect, useState, useRef } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import FloatLabel from "../../../UiComponents/FloatLabel/FloatLabel";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { DatePicker } from "antd";
import {
  GetSubBookingCode,
  GetBookingReport,
  GetCompany,
  downloadBookingReport,
  formatNumber,
  ReframeEndDateTimeFormat,
} from "../../../Service/_index";
import "./index.scss";
import MasterCommonTable from "../../../UiComponents/CommonTable/MasterCommonTable";
import {
  Card,
  CardContent,
  Checkbox,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Stack,
  Badge,
  Skeleton,
} from "@mui/material";
import CloudDownloadOutlinedIcon from "@mui/icons-material/CloudDownloadOutlined";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import TabFilter from "../../Tabs/Tabs";
import Input from "@mui/material/Input";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import {
  SearchIcon,
  DownloadIcon,
  CloudOffIcon,
} from "../../../Resources/Icons/icons";
import filterr from "../../../Resources/Images/filter-lines.png";
import exportt from "../../../Resources/Images/export.png";
import FilterBox from "../../../UiComponents/FilterBox/FilterBox";
import CustomButton from "../../../UiComponents/CommonBUtton/ConfirmBox";
import { CSVLink } from "react-csv";
import dayjs from "dayjs";
import download from "../../../Resources/Images/whiteDownload.png";
import view from "../../../Resources/Images/view copy.png";
import file from "../../../Resources/Images/file.png";
import car from "../../../Resources/Images/car.png";
import tpCar from "../../../Resources/Images/tpCar.png";
import net from "../../../Resources/Images/net.png";
import total from "../../../Resources/Images/total.png";

import * as ExcelJS from "exceljs";
import { saveAs } from "file-saver";

import FilterListIcon from "@mui/icons-material/FilterList";
import { formatLoginIdForReport } from "../../../Shared/loginId";

const { RangePicker } = DatePicker;

const BookingScoreOption = [
  { _id: 1, label: "Default", value: true },
  { _id: 2, label: "Custom", value: false },
];

const BookingReport = () => {
  const [selectedScore, setSelectedScore] = useState(1);
  const [bookingCodeDetails, setBookingCodeDetails] = useState([]);
  const [bookingReportData, setBookingReportData] = useState();
  const [isShowRangePicker, setIsShowRangePicker] = useState(true);
  const [filterBy, setFilterBy] = useState({});
  const [tableConfig, setTableConfig] = useState({
    isDelete: true,
    isSearch: true,
    isApprove: true,
  });
  const [company, setCompany] = React.useState([]);
  const [openCompanyDrawer, setOpenCompanyDrawer] = React.useState(false);
  const [formType, setFormType] = useState("");
  const [selectedData, setSelectedData] = React.useState({});
  const [openConfirmBox, setOpenConfirmBox] = React.useState(false);
  const [page, setPage] = React.useState(0);
  const [activeBoolean, setActiveBoolean] = useState();
  const [selectedTab, setSelectedTab] = useState(1);
  const [openDeleteConfirmBox, setOpenDeleteConfirmBox] = React.useState(false);
  const [searchText, setSearchText] = useState("");
  const [details, setDetails] = useState("");
  const [showDate, setShowDate] = useState(false);
  const [dateRange, setDateRange] = useState([]);
  const [openLoader, setOpenLoader] = useState(false);
  const lastAppliedFilterRef = useRef(null);
  const [showFilter, setShowFilter] = useState(false);

  // headers for excel export (same as your old working file)
  // Changed by Arun
  const userHeaders = [
    { header: "Approve Date", key: "approveDate", id: "Policy Details" }, // Changes by Arun
    { header: "Issue Date", key: "formateIssueDate", id: "Policy Details" },
    { header: "User Name", key: "userName", id: "Policy Details" }, // Changes by Arun
    // { header: "Status", key: "branchManagerName", id: "Policy Details" },
    { header: "Booking Code", key: "bookingCode", id: "Policy Details" }, // Changes by Arun
    { header: "Sub Booking Code", key: "subBookingCode", id: "Policy Details" }, // Changes by Arun
    { header: "Company Name", key: "company", id: "Policy Details" },
    { header: "Product", key: "product", id: "Policy Details" }, // Changes by Arun
    { header: "Sub Product", key: "subProduct", id: "Policy Details" }, // Changes by Arun
    { header: "Policy Type", key: "policyType", id: "Policy Details" }, // Changes by Arun
    { header: "Policy Number", key: "policyNumber", id: "Policy Details" },
    { header: "Login Id", key: "loginID", id: "Policy Details" },
    {
      header: "Customer Name",
      key: "customerName",
      id: "Customer Details", //Changes by Arun
    },
    {
      header: "Mobile",
      key: "mobileNumber",
      id: "Customer Details", //Changes by Arun
    },
    {
      header: "Email",
      key: "email",
      id: "Customer Details", //Changes by Arun
    },
    {
      header: "RTO",
      key: "rtoId",
      id: "Vehicle Details", //Changes by sankarNagarajan
    },
    {
      header: "Reg Number",
      key: "registrationNumber",
      id: "Vehicle Details", //Changes by Arun
    },
    {
      header: "Vechicle Make",
      key: "vehicleMake",
      id: "Vehicle Details", //Changes by Arun
    },
    {
      header: "Model",
      key: "model",
      id: "Vehicle Details", //Changes by Arun
    },
    {
      header: "Reg Year",
      key: "registrationYear",
      id: "Vehicle Details", //Changes by Arun
    },

    {
      header: "GVW",
      key: "gvw",
      id: "Vehicle Details", //Changes by Arun
    },
    {
      header: "CC",
      key: "cc",
      id: "Vehicle Details", //Changes by Arun
    },
    {
      header: "Seat Capacity",
      key: "seatingCapacity",
      id: "Vehicle Details", //Changes by Arun
    },
    {
      header: "Fuel Type",
      key: "fuelType",
      id: "Vehicle Details", //Changes by Arun
    },
    {
      header: "PA Cover",
      key: "paCover",
      id: "Premium Details", //Changes by Arun
    },
    {
      header: "OD Discount",
      key: "odDisc",
      id: "Premium Details", //Changes by Arun
    },
    {
      header: "OD Premium",
      key: "odPremium",
      id: "Premium Details", //Changes by Arun
    },
    {
      header: "TP Premium",
      key: "tpPremium",
      id: "Premium Details", //Changes by Arun
    },
    {
      header: "Net Premium",
      key: "netPremium",
      id: "Premium Details", //Changes by Arun
    },
    {
      header: "Total Premium",
      key: "totalPremium",
      id: "Premium Details", //Changes by Arun
    },
    {
      header: "OD Start Date",
      key: "formateOdPolicyStartDate",
      id: "Policy Period", // Changes by Arun
    },
    {
      header: "OD Period",
      key: "odPolicyPeriod",
      id: "Policy Period", // Changes by Arun
    },
    {
      header: "OD End Date",
      key: "formateOdPolicyEndDate",
      id: "Policy Period", // Changes by Arun
    },
    {
      header: "TP Start Date",
      key: "formateTpPolicyStartDate",
      id: "Policy Period", // Changes by Arun
    },
    {
      header: "TP Period",
      key: "tpPolicyPeriod",
      id: "Policy Period", // Changes by Arun
    },
    {
      header: "TP End Date",
      key: "formateTpPolicyEndDate",
      id: "Policy Period", // Changes by Arun
    },
    {
      header: "OD %",
      key: "payODPer",
      id: "User Payable", //Changes by Arun
    },
    {
      header: "OD Amt",
      key: "payODAmount",
      id: "User Payable", //Changes by Arun
    },
    {
      header: "TP %",
      key: "payTPPer",
      id: "User Payable", //Changes by Arun
    },
    {
      header: "TP Amt",
      key: "payTPAmount",
      id: "User Payable", //Changes by Arun
    },
    {
      header: "Net %",
      key: "payNetPer",
      id: "User Payable", //Changes by Arun
    },
    {
      header: "Net Amt",
      key: "payNetAmount",
      id: "User Payable", //Changes by Arun
    },
    {
      header: "Total Amount",
      key: "payOdTpNetTotal",
      id: "User Payable",
    },
  ];

  // Changed by Arun
  const subBookingCodeUserHeaders = [
    { header: "Approve Date", key: "approveDate", id: "Policy Details" }, // Changes by Arun
    { header: "Issue Date", key: "formateIssueDate", id: "Policy Details" },
    // { header: "User Name", key: "userName", id: "Policy Details" }, // Changes by Arun
    // { header: "Branch Manager", key: "branchManagerName", id: "Policy Details" },
    { header: "Booking Code", key: "bookingCode", id: "Policy Details" }, // Changes by Arun
    { header: "Sub Booking Code", key: "subBookingCode", id: "Policy Details" }, // Changes by Arun
    { header: "Company Name", key: "company", id: "Policy Details" },
    { header: "Product", key: "product", id: "Policy Details" }, // Changes by Arun
    { header: "Sub Product", key: "subProduct", id: "Policy Details" }, // Changes by Arun
    { header: "Policy Type", key: "policyType", id: "Policy Details" }, // Changes by Arun
    { header: "Policy Number", key: "policyNumber", id: "Policy Details" },
    { header: "Login Id", key: "loginID", id: "Policy Details" },
    {
      header: "Customer Name",
      key: "customerName",
      id: "Customer Details", //Changes by Arun
    },
    {
      header: "RTO",
      key: "rtoId",
      id: "Vehicle Details", //Changes by sankarNagarajan
    },
    {
      header: "Reg Number",
      key: "registrationNumber",
      id: "Vehicle Details", //Changes by Arun
    },
    {
      header: "Vechicle Make",
      key: "vehicleMake",
      id: "Vehicle Details", //Changes by Arun
    },
    {
      header: "Model",
      key: "model",
      id: "Vehicle Details", //Changes by Arun
    },
    {
      header: "Reg Year",
      key: "registrationYear",
      id: "Vehicle Details", //Changes by Arun
    },

    {
      header: "GVW",
      key: "gvw",
      id: "Vehicle Details", //Changes by Arun
    },
    {
      header: "CC",
      key: "cc",
      id: "Vehicle Details", //Changes by Arun
    },
    {
      header: "Seat Capacity",
      key: "seatingCapacity",
      id: "Vehicle Details", //Changes by Arun
    },
    {
      header: "Fuel Type",
      key: "fuelType",
      id: "Vehicle Details", //Changes by Arun
    },
    {
      header: "PA Cover",
      key: "paCover",
      id: "Premium Details", //Changes by Arun
    },
    {
      header: "OD Discount",
      key: "odDisc",
      id: "Premium Details", //Changes by Arun
    },
    {
      header: "OD Premium",
      key: "odPremium",
      id: "Premium Details", //Changes by Arun
    },
    {
      header: "TP Premium",
      key: "tpPremium",
      id: "Premium Details", //Changes by Arun
    },
    {
      header: "Net Premium",
      key: "netPremium",
      id: "Premium Details", //Changes by Arun
    },
    {
      header: "Total Premium",
      key: "totalPremium",
      id: "Premium Details", //Changes by Arun
    },
    {
      header: "OD Start Date",
      key: "formateOdPolicyStartDate",
      id: "Policy Period", // Changes by Arun
    },
    {
      header: "OD Period",
      key: "odPolicyPeriod",
      id: "Policy Period", // Changes by Arun
    },
    {
      header: "OD End Date",
      key: "formateOdPolicyEndDate",
      id: "Policy Period", // Changes by Arun
    },
    {
      header: "TP Start Date",
      key: "formateTpPolicyStartDate",
      id: "Policy Period", // Changes by Arun
    },
    {
      header: "TP Period",
      key: "tpPolicyPeriod",
      id: "Policy Period", // Changes by Arun
    },
    {
      header: "TP End Date",
      key: "formateTpPolicyEndDate",
      id: "Policy Period", // Changes by Arun
    },
    {
      header: "OD %",
      key: "recODPer",
      id: "Receivable", //Changes by Arun
    },
    {
      header: "OD Amt",
      key: "recODAmount",
      id: "Receivable", //Changes by Arun
    },
    {
      header: "TP %",
      key: "recTPPer",
      id: "Receivable", //Changes by Arun
    },
    {
      header: "TP Amt",
      key: "recTPAmount",
      id: "Receivable", //Changes by Arun
    },
    {
      header: "Net %",
      key: "recNetPer",
      id: "Receivable", //Changes by Arun
    },
    {
      header: "Net Amt",
      key: "recNetAmount",
      id: "Receivable", //Changes by Arun
    },
    {
      header: "Total Amount",
      key: "recOdTpNetTotal",
      id: "Receivable",
    },
  ];

  const GetBookingCodeDetails = () => {
    GetSubBookingCode({ isAscending: true }).then((res) => {
      if (res?.data && Array.isArray(res.data)) {
        let FilteredData = [];
        res.data.map((e) => {
          if (e.isEnabled) {
            FilteredData.push({
              ...e,
              label: e.bookingCode + " - " + e.subBookingCode,
              value: e._id,
              _id: e._id,
              bookingCodeId: e.bookingCodeId || e.bookingCodeId,
            });
          }
        });
        setBookingCodeDetails(FilteredData);

        // A SUBCODE user only ever gets their own code back, so there is
        // nothing to choose — preselect it. Single-select, so `details` holds
        // the _id, which is what FilterBox matches on to show the selection.
        // Only when exactly one comes back; a user with several must choose.
        // The report itself still waits for Search — this page deliberately
        // does not call the API on mount (see the effect below).
        if (
          sessionStorage.getItem("userType") === "SUBCODE" &&
          FilteredData.length === 1
        ) {
          setDetails(FilteredData[0]._id);
        }
      }
    });
  };

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
    const selectedOption = FilterOption.find(
      (option) => option.value === newValue
    );
    // FilterCompanyFunction(selectedOption);
  };

  const [filter, setFilter] = useState({
    fn: (items) => {
      return items;
    },
  });

  // getBookingReport handles both fetch and excel download
  const getBookingReport = async (
    isDownloadExcel = false,
    currentFilters = filterBy,
    // Which card's Export was clicked: "today" | "monthly" | "total".
    // The backend narrows the exported rows to that card's period. Left null
    // by the toolbar Export, which keeps downloading the full filtered set.
    cardType = null
  ) => {
    console.log("currentFilters", currentFilters);
    try {
      const reqBody = { ...currentFilters };
      // If user provided an end date and you want to reframe to end of day
      if (reqBody.selectedEndDate) {
        // keep behaviour same as old file: reframe selectedEndDate and also today's end date if needed
        const reframedSelectedEnd = await ReframeEndDateTimeFormat(
          reqBody.selectedEndDate
        );
        const endDate = await ReframeEndDateTimeFormat(new Date());
        reqBody.selectedEndDate = reframedSelectedEnd;
        reqBody.todayStartDate = new Date(
          new Date().getUTCFullYear(),
          new Date().getUTCMonth(),
          new Date().getUTCDate()
        );
        reqBody.todayEndDate = endDate;
      }

      const selectedScoreOption = BookingScoreOption.find(
        (option) => option._id === selectedScore
      );

      // The Today card is bounded by today's date, not the picked range, so its
      // bounds must be present even on a DEFAULT request — the block above only
      // sets them when a custom end date was chosen.
      if (cardType === "today") {
        const now = new Date();
        reqBody.todayStartDate = new Date(
          now.getUTCFullYear(),
          now.getUTCMonth(),
          now.getUTCDate()
        );
        reqBody.todayEndDate = await ReframeEndDateTimeFormat(new Date());
      }

      const finalReqBody = {
        ...reqBody,
        requestType:
          selectedScoreOption?.value === false ? "CUSTOM" : "DEFAULT",
        ...(cardType && { cardType }),
      };

      setOpenLoader(true);

      if (isDownloadExcel) {
        const UserType = sessionStorage.getItem("userType");
        let selectedColumns = UserType == "SUBCODE" ? subBookingCodeUserHeaders : userHeaders;
        const selectedHeader = [
          ...new Set(selectedColumns.map((element) => element?.id)),
        ];
        finalReqBody.selectedHeader = selectedHeader;

        // use the downloadBookingReport service (same as your old code)
        const res = await downloadBookingReport(finalReqBody);
        const FormatedData = res?.data ? res.data : [];

        // Drops the user-name suffix the login portal appends, keeping login ids
        // that contain a dash of their own (Shriram's "LC288-474") intact.
        FormatedData.forEach((element) => {
          element.loginID = formatLoginIdForReport(
            element.loginId || element.loginID,
            element.userName,
          );
        });

        // build excel workbook and worksheet
        const wb = new ExcelJS.Workbook();
        const cardFileLabel = { today: "Today", monthly: "This Month", total: "Total" }[cardType];
        const workbookName = cardFileLabel
          ? `Booking Report - ${cardFileLabel}.xlsx`
          : "Booking Report.xlsx";
        const worksheetName = "Booking Report";
        const ws = wb.addWorksheet(worksheetName, {
          properties: {
            tabColor: { argb: "FFFF0000" },
          },
        });

        ws.columns = selectedColumns;
        ws.addRows(FormatedData);

        ws.eachRow((row) => {
          row.eachCell({ includeEmpty: true }, (cell) => {
            cell.border = {
              top: { style: "thin" },
              left: { style: "thin" },
              bottom: { style: "thin" },
              right: { style: "thin" },
            };
          });
        });

        const buffer = await wb.xlsx.writeBuffer();
        saveAs(
          new Blob([buffer], { type: "application/octet-stream" }),
          workbookName
        );
      } else {
        const res = await GetBookingReport(finalReqBody);
        setBookingReportData(res.data);
      }
    } catch (err) {
      console.error("getBookingReport error:", err);
    } finally {
      setOpenLoader(false);
    }
  };

  useEffect(() => {
    GetBookingCodeDetails();
    // Don't call API on initial mount - only when user clicks Search
  }, []);

  // FilteredData example (keeps your old code but .includes() requires a value)
  const FilteredData = company.filter((el) => {
    if (!searchText) return true;
    const text = `${el?.companyName || ""},${el?.remarks || ""},${el?.shortName || ""
      }`.toLowerCase();
    return text.includes(searchText.toLowerCase());
  });

  const headCells = [
    {
      id: "S.No",
      placeMent: true,
      disablePadding: false,
      label: "S.No",
    },
    {
      id: "UserName",
      placeMent: true,
      disablePadding: false,
      label: "User Name",
    },
    {
      id: "VehicleName",
      placeMent: true,
      disablePadding: false,
      label: "Vehicle Name",
    },
    {
      id: "VehicleCount",
      placeMent: true,
      disablePadding: false,
      label: "Vehicle Count",
    },
  ];

  const FilterOption = [
    {
      label: "Pending",
      isEnabled: "all",
      value: 1,
    },
    {
      label: "Approved",
      isEnabled: "true",
      value: 2,
    },
  ];

  const data = [
    { label: "Today", key: "today" },
    { label: "This Month", key: "monthly" },
    { label: "Total", key: "total" },
    { label: "Receivable", key: "receivable" },
  ];

  const fields = ["Policy Count", "OD", "TP", "NET", "Total"];

  // The Receivable card is not an OD/TP/NET breakdown — it has its own rows, in
  // its own order, and no Total. Kept as a separate list rather than aliasing
  // the generic fields above (OD->Received, TP->Receivable, NET->Pending),
  // which made the order impossible to change without touching every card.
  const receivableFields = [
    "Policy Count",
    "Receivable",
    "Received",
    "Pending",
  ];

  const filterBoxData = [
    {
      id: 1,
      label: "Filter Type ",
      data: BookingScoreOption,
      setState: setSelectedScore,
      value: selectedScore,
      type: "input",
      variation: "single",
    },
    {
      id: 2,
      label: "Booking Code & SubBooking Code",
      data: bookingCodeDetails,
      setState: setDetails,
      value: details,
      type: "input",
      variation: "single",
    },
    ...(showDate
      ? [
        {
          id: 3,
          label: "",
          setDate: setDateRange,
          type: "noDefaultDate",
        },
      ]
      : []),
  ];

  useEffect(() => {
    // your logic: if selectedScore equals 2 (custom) show date selector
    if (
      selectedScore === 2 ||
      selectedScore === "2" ||
      selectedScore === false
    ) {
      setShowDate(true);
    } else {
      setShowDate(false);
    }
  }, [selectedScore]);

  // The report only runs when Search is clicked (FilterBox autoApply={false}); picking a date must not trigger it.

  // derive filters on change via handleSaveAllFilter

  const handleClearAllState = () => {
    setDetails(null);
    setSelectedScore(1);
    setDateRange([]);
    setFilterBy({});
    setShowDate(false);
  };

  const handleClearSingleFilter = (filterId) => {
    if (filterId === 1) {
      setSelectedScore(1);
      setShowDate(false);
    } else if (filterId === 2) {
      setDetails(null);
    } else if (filterId === 3) {
      setDateRange([]);
    }
  };

  const handleSaveAllFilter = () => {
    const computedFilter = { ...filterBy };

    if (details) {
      const bookingCode = bookingCodeDetails.find(
        (item) => item?._id === details
      )?.bookingCodeId;

      computedFilter.subBookingCode = details;
      if (bookingCode) {
        computedFilter.bookingCode = bookingCode;
      } else {
        delete computedFilter.bookingCode;
      }
    } else {
      delete computedFilter.subBookingCode;
      delete computedFilter.bookingCode;
    }

    const selectedOption = BookingScoreOption.find(
      (option) => option._id === selectedScore
    );

    const isCustom = selectedOption?.value === false;

    let effectiveDateRange = dateRange;

    if (isCustom) {
      if (!effectiveDateRange || effectiveDateRange.length !== 2) {
        if (filterBy.selectedStartDate && filterBy.selectedEndDate) {
          effectiveDateRange = [
            filterBy.selectedStartDate,
            filterBy.selectedEndDate,
          ];
        } else {
          const todayStart = dayjs().startOf("day");
          const todayEnd = dayjs().endOf("day");
          effectiveDateRange = [todayStart, todayEnd];
        }
      }
    }

    if (effectiveDateRange && effectiveDateRange.length === 2) {
      computedFilter.selectedStartDate = dayjs(effectiveDateRange[0]);
      computedFilter.selectedEndDate = dayjs(effectiveDateRange[1]);
    } else {
      delete computedFilter.selectedStartDate;
      delete computedFilter.selectedEndDate;
    }

    // Update filterBy state and make API call
    // This function is called when user clicks Search button in FilterBox
    setFilterBy(computedFilter);
    getBookingReport(false, computedFilter);
  };

  const activeFiltersCount =
    (selectedScore ? 1 : 0) + (details ? 1 : 0) + (dateRange?.[0] ? 1 : 0);

  return (
    <>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        <Box sx={{ position: "relative", zIndex: 1, mt: 0 }}>
          <Grid container className="Master_Card_Container">
            <Grid
              container
              alignItems="center"
              className="Master_Card_Sub_Container"
              sx={{ mb: 2 }}
            >
              <Grid item xs={12} sm={6} md={4}>
                <Typography
                  sx={{
                    fontFamily: "Inter",
                    fontSize: "18px",
                    color: "#101828",
                    fontWeight: "500",
                  }}
                >
                  Booking Report
                </Typography>
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={8}
                className="d-flex"
                justifyContent={{
                  xs: "start",
                  sm: "flex-end",
                  md: "flex-end",
                }}
              >
                <Stack
                  direction={{ xs: "column", sm: "row", md: "row" }}
                  spacing={2}
                  mt={{ xs: 2, sm: 2, md: 0 }}
                >
                  <Stack direction="row" spacing={2} sx={{ width: "100%" }}>
                    <Button
                      className="Master_Card_Filter_Button w-100"
                      sx={{ width: "102px", height: "40px", gap: "8px" }}
                      startIcon={
                        <Badge
                          badgeContent={activeFiltersCount}
                          color="error"
                          sx={{
                            "& .MuiBadge-badge": {
                              right: 5,
                              top: 3,
                              width: "14px",
                              height: "14px",
                              minWidth: "14px",
                              borderRadius: "50%",
                              fontSize: "8.91px",
                              fontWeight: "600",
                              backgroundColor: "#E50000",
                              color: "#fff",
                              padding: 0,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            },
                          }}
                        >
                          <FilterListIcon sx={{ marginRight: "1.5px" }} />
                        </Badge>
                      }
                      onClick={() => setShowFilter(!showFilter)}
                    >
                      Filters
                    </Button>
                    <Button
                      className="Master_Card_Filter_Button w-100"
                      sx={{ width: "102px", height: "40px", gap: "8px" }}
                      fullWidth
                      startIcon={
                        <CloudDownloadOutlinedIcon
                          sx={{
                            color: "#344054",
                          }}
                        />
                      }
                      onClick={() => getBookingReport(true)}
                    >
                      Export
                    </Button>
                  </Stack>
                </Stack>
              </Grid>
            </Grid>

            {showFilter && (
              <Box
                sx={{
                  mb: 2,
                  overflow: "visible",
                  position: "relative",
                  zIndex: 1200,
                  minHeight: "60px",
                  width: "100%",
                }}
              >
                <FilterBox
                  filterData={filterBoxData}
                  type={"single"}
                  handleClearAllState={handleClearAllState}
                  handleSaveAllFilter={handleSaveAllFilter}
                  handleClearSingleFilter={handleClearSingleFilter}
                  horizontalLayout={true}
                  hideHeader={true}
                  hideInput={true}
                  alwaysOpen={true}
                  autoApply={false}
                />
              </Box>
            )}

            <Grid item xs={12}>
              <Divider
                sx={{
                  backgroundColor: "#EAECF0",
                  borderWidth: 1,
                }}
              />
            </Grid>
            <Grid container padding={2} spacing={2}>
              {data?.map(({ label, key }, index) => (
                <Grid item xs={12} sm={6} md={3} key={key}>
                  {openLoader ? (
                    <Box
                      sx={{
                        border: "1px solid #EAECF0",
                        borderRadius: "6px",
                        backgroundColor: "#FDFDFD",
                        width: "95%",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <Box
                        sx={{
                          borderBottom: "1px solid #EAECF0",
                          width: "100%",
                          padding: "10px",
                        }}
                      >
                        <Skeleton
                          variant="text"
                          width="60%"
                          height={30}
                          sx={{ margin: "0 auto" }}
                          animation="wave"
                        />
                      </Box>
                      <Box sx={{ padding: "16px" }}>
                        {[1, 2, 3, 4, 5].map((i) => (
                          <Box
                            key={i}
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              padding: "10px",
                              mb: 1,
                            }}
                          >
                            <Skeleton
                              variant="circular"
                              width={15}
                              height={15}
                              animation="wave"
                            />
                            <Skeleton
                              variant="text"
                              width="30%"
                              height={20}
                              animation="wave"
                            />
                            <Skeleton
                              variant="text"
                              width="20%"
                              height={20}
                              animation="wave"
                            />
                          </Box>
                        ))}
                      </Box>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          marginBottom: "10px",
                        }}
                      >
                        <Skeleton
                          variant="rectangular"
                          width={100}
                          height={40}
                          sx={{ borderRadius: "8px" }}
                          animation="wave"
                        />
                      </Box>
                    </Box>
                  ) : (
                    <Box
                      sx={{
                        border: "1px solid #EAECF0",
                        borderRadius: "6px",
                        backgroundColor: "#FDFDFD",
                        width: "95%",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <Box
                        sx={{
                          borderBottom: "1px solid #EAECF0",
                          width: "100%",
                          padding: "10px",
                        }}
                      >
                        <Typography
                          gutterBottom
                          sx={{
                            color: "#1E3A5F",
                            fontSize: "18px",
                            fontFamily: "Inter",
                            fontWeight: "600",
                            textAlign: "center",
                          }}
                        >
                          {label}
                        </Typography>
                      </Box>
                      <Box sx={{ padding: "16px" }}>
                        {(key === "receivable"
                          ? receivableFields
                          : fields
                        )?.map((field, idx) => {
                          let fieldValue = "-";
                          let displayLabel = field;

                          if (bookingReportData?.[key]) {
                            if (key === "receivable") {
                              if (field === "Policy Count") {
                                fieldValue = bookingReportData[key]?.policyCount ?? 0;
                              } else if (field === "Receivable") {
                                fieldValue = bookingReportData[key]?.totalReceivable ?? 0;
                              } else if (field === "Received") {
                                fieldValue = bookingReportData[key]?.totalReceived ?? 0;
                              } else if (field === "Pending") {
                                fieldValue = bookingReportData[key]?.pending ?? 0;
                              }
                            } else {
                              if (field === "Policy Count")
                                fieldValue =
                                  bookingReportData[key]?.policyCount ?? 0;
                              else if (field === "OD")
                                fieldValue =
                                  bookingReportData[key]?.odTotal ?? 0;
                              else if (field === "TP")
                                fieldValue =
                                  bookingReportData[key]?.tpTotal ?? 0;
                              else if (field === "NET")
                                fieldValue =
                                  bookingReportData[key]?.netTotal ?? 0;
                              else if (field === "Total")
                                fieldValue =
                                  bookingReportData[key]?.total ?? 0;
                            }
                          }

                          return (
                            <Box
                              key={field}
                              sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                padding: "10px",
                                backgroundColor:
                                  idx % 2 === 0 ? "#FFFFFF" : "#EEEEF8",
                              }}
                            >
                              {idx === 0 ? (
                                <img src={file} width="15px" height="15px" />
                              ) : idx === 1 ? (
                                <img src={car} width="15px" height="15px" />
                              ) : idx === 2 ? (
                                <img src={tpCar} width="15px" height="15px" />
                              ) : idx === 3 ? (
                                <img src={net} width="15px" height="15px" />
                              ) : (
                                <img src={total} width="15px" height="15px" />
                              )}
                              <Typography
                                sx={{
                                  color: "#667085",
                                  fontWeight: "400",
                                  fontSize: "14px",
                                  fontFamily: "Inter",
                                }}
                              >
                                {displayLabel}:
                              </Typography>
                              <Typography
                                sx={{
                                  color: "#000",
                                  fontWeight: "400",
                                  fontSize: "14px",
                                  fontFamily: "Inter",
                                  wordBreak: "break-all",
                                  textAlign: "right",
                                  minWidth: 0,
                                  flex: 1,
                                  overflowWrap: "break-word",
                                  hyphens: "auto",
                                }}
                              >
                                {fieldValue === "-"
                                  ? "-"
                                  : formatNumber(fieldValue)}
                              </Typography>
                            </Box>
                          );
                        })}
                      </Box>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          marginBottom: "10px",
                        }}
                      >
                        <Button
                          sx={{
                            backgroundColor: "#1E3A5F",
                            padding: "10px 20px",
                            borderRadius: "8px",
                            display: "flex",
                            gap: "8px",
                            "&:hover": {
                              backgroundColor: "#1E3A5F",
                            },
                          }}
                          onClick={() => {
                            // index === 3 (Receivable) View -> just fetch/display
                            if (index === 3) {
                              getBookingReport(false);
                            } else {
                              // Export only this card's rows — `key` is the same
                              // bucket the card's figures were read from.
                              getBookingReport(true, filterBy, key);
                            }
                          }}
                        >
                          {index === 3 ? (
                            <img src={view} width="20px" height="20px" />
                          ) : (
                            <img src={download} width="15px" height="15px" />
                          )}
                          <Typography
                            sx={{
                              textTransform: "none",
                              color: "#fff",
                              fontSize: "14px",
                              fontFamily: "Inter",
                              fontWeight: "500",
                            }}
                          >
                            {index === 3 ? `View` : `Export`}
                          </Typography>
                        </Button>
                      </Box>
                    </Box>
                  )}
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Box>
      </Box>

    </>
  );
};
export default BookingReport;
